import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ILicenseItem,
  ILicensePackage,
  IMPESASTKPush,
  ISubscriptionLicense,
  ISubscriptionLicenseInvoice,
  ISubscriptionRemainingFree,
  SIBASI_SYSTEM_APP_MODULES
} from 'src/app/common/model/license.model';
import { ISibasiHTTPResponse } from 'src/app/common/model/sibasiHTTPResponse.model';
import { IPagination } from 'src/app/common/model/util.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {
  constructor(private http: HttpClient) {}

  // *************** SUBSCRIPTIONS ITEMS ADMIN ***************

  public getAllLicenseItemsAdmin(): Observable<ISibasiHTTPResponse<ILicenseItem[]>> {
    return this.http.get<ISibasiHTTPResponse<ILicenseItem[]>>(
      `${environment.api_url}admin/sibasi-subscription-items`
    );
  }
  public getLicenseItemByIdAdmin(
    licenseItemId: string
  ): Observable<ISibasiHTTPResponse<ILicenseItem>> {
    return this.http.get<ISibasiHTTPResponse<ILicenseItem>>(
      `${environment.api_url}admin/sibasi-subscription-items/${licenseItemId}`
    );
  }
  public addLicenseItemAdmin(
    licenseItem: ILicenseItem
  ): Observable<ISibasiHTTPResponse<ILicenseItem>> {
    return this.http.post<ISibasiHTTPResponse<ILicenseItem>>(
      `${environment.api_url}admin/sibasi-subscription-items`,
      licenseItem
    );
  }
  public deleteLicenseItemAdmin(
    licenseItemId: any
  ): Observable<ISibasiHTTPResponse<ILicenseItem>> {
    return this.http.delete<ISibasiHTTPResponse<ILicenseItem>>(
      `${environment.api_url}admin/sibasi-subscription-items/${licenseItemId}`
    );
  }
  public updateLicenseItemAdmin(
    licenseItemId: any,
    licenseItem: ILicenseItem
  ): Observable<ISibasiHTTPResponse<ILicenseItem>> {
    return this.http.post<ISibasiHTTPResponse<ILicenseItem>>(
      `${environment.api_url}admin/sibasi-subscription-items/${licenseItemId}`,
      licenseItem
    );
  }

  // *************** SUBSCRIPTIONS ITEMS PUBLIC ***************

  public getAllLicenseItemsPublic(): Observable<ISibasiHTTPResponse<ILicenseItem[]>> {
    return this.http.get<ISibasiHTTPResponse<ILicenseItem[]>>(
      `${environment.api_url}public/sibasi-subscription-items`
    );
  }
  public getLicenseItemByIdPublic(
    licenseItemId: string
  ): Observable<ISibasiHTTPResponse<ILicenseItem>> {
    return this.http.get<ISibasiHTTPResponse<ILicenseItem>>(
      `${environment.api_url}public/sibasi-subscription-items/${licenseItemId}`
    );
  }
  public getAllLicenseItemsPublicIsLicensed(): Observable<
    ISibasiHTTPResponse<ILicenseItem[]>
  > {
    return this.http.get<ISibasiHTTPResponse<ILicenseItem[]>>(
      `${environment.api_url}public/sibasi-subscription-items/islicensed/all`
    );
  }
  public getLicenseItemByIdPublicIsLicensed(
    licenseItemId: string
  ): Observable<ISibasiHTTPResponse<ILicenseItem>> {
    return this.http.get<ISibasiHTTPResponse<ILicenseItem>>(
      `${environment.api_url}public/sibasi-subscription-items/islicensed/one/${licenseItemId}`
    );
  }
  public activatedTrialLicense(): Observable<ISibasiHTTPResponse<ILicenseItem>> {
    return this.http.get<ISibasiHTTPResponse<ILicenseItem>>(
      `${environment.api_url}sibasi-subscription-item-licenses/activate/trial`
    );
  }

  // *************** SUBSCRIPTIONS PACKAGES ADMIN ***************

  public getAllLicensePackagesAdmin(): Observable<
    ISibasiHTTPResponse<ILicensePackage[]>
  > {
    return this.http.get<ISibasiHTTPResponse<ILicensePackage[]>>(
      `${environment.api_url}admin/sibasi-subscription-packages`
    );
  }
  public getLicensePackageByIdAdmin(
    licensePackageId: string
  ): Observable<ISibasiHTTPResponse<ILicensePackage>> {
    return this.http.get<ISibasiHTTPResponse<ILicensePackage>>(
      `${environment.api_url}admin/sibasi-subscription-packages/${licensePackageId}`
    );
  }
  public addLicensePackageAdmin(
    licensePackage: ILicensePackage
  ): Observable<ISibasiHTTPResponse<ILicensePackage>> {
    return this.http.post<ISibasiHTTPResponse<ILicensePackage>>(
      `${environment.api_url}admin/sibasi-subscription-packages`,
      licensePackage
    );
  }
  public deleteLicensePackageAdmin(
    licensePackageId: any
  ): Observable<ISibasiHTTPResponse<ILicensePackage>> {
    return this.http.delete<ISibasiHTTPResponse<ILicensePackage>>(
      `${environment.api_url}admin/sibasi-subscription-packages/${licensePackageId}`
    );
  }
  public updateLicensePackageAdmin(
    licensePackageId: any,
    licensePackage: ILicensePackage
  ): Observable<ISibasiHTTPResponse<ILicensePackage>> {
    return this.http.post<ISibasiHTTPResponse<ILicensePackage>>(
      `${environment.api_url}admin/sibasi-subscription-packages/${licensePackageId}`,
      licensePackage
    );
  }
  public updateExistingPackageLicenses(
    licensePackageId: any
  ): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}sibasi-subscription-item-licenses/admin/package/updateLicenseSubscribedModules/${licensePackageId}`
    );
  }

  // *************** SUBSCRIPTIONS PACKAGES PUBLIC ***************

  public getAllLicensePackagesPublic(): Observable<
    ISibasiHTTPResponse<ILicensePackage[]>
  > {
    return this.http.get<ISibasiHTTPResponse<ILicensePackage[]>>(
      `${environment.api_url}public/sibasi-subscription-packages`
    );
  }
  public getLicensePackageByIdPublic(
    licensePackageId: string
  ): Observable<ISibasiHTTPResponse<ILicensePackage>> {
    return this.http.get<ISibasiHTTPResponse<ILicensePackage>>(
      `${environment.api_url}public/sibasi-subscription-packages/${licensePackageId}`
    );
  }
  public getAllLicensePackagesPublicIsLicensed(): Observable<
    ISibasiHTTPResponse<ILicensePackage[]>
  > {
    return this.http.get<ISibasiHTTPResponse<ILicensePackage[]>>(
      `${environment.api_url}public/sibasi-subscription-Packages/islicensed/all`
    );
  }
  public getAllLicensePackagesByCountry(
    countryCode: string
  ): Observable<ISibasiHTTPResponse<ILicensePackage[]>> {
    return this.http.get<ISibasiHTTPResponse<ILicensePackage[]>>(
      `${environment.api_url}public/sibasi-subscription-Packages/islicensed/all/${countryCode}`
    );
  }
  public getLicensePackageByIdPublicIsLicensed(
    licensePackageId: string
  ): Observable<ISibasiHTTPResponse<ILicensePackage>> {
    return this.http.get<ISibasiHTTPResponse<ILicensePackage>>(
      `${environment.api_url}public/sibasi-subscription-Packages/islicensed/one/${licensePackageId}`
    );
  }

  // *************** SUBSCRIPTIONS LICENSE ***************

  public createSubscriptionLicense(
    subscriptionLicense: Partial<ISubscriptionLicense>
  ): Observable<ISibasiHTTPResponse<ISubscriptionLicense>> {
    return this.http.post<ISibasiHTTPResponse<ISubscriptionLicense>>(
      `${environment.api_url}sibasi-subscription-item-licenses`,
      subscriptionLicense
    );
  }
  public getSubscriptionLicenses(): Observable<
    ISibasiHTTPResponse<ISubscriptionLicense[]>
  > {
    return this.http.get<ISibasiHTTPResponse<ISubscriptionLicense[]>>(
      `${environment.api_url}sibasi-subscription-item-licenses/active/all`
    );
  }

  // *************** MPESA PAYMENT ***************

  public triggerMPESASTKPush(
    MPESASTKPush: IMPESASTKPush
  ): Observable<ISibasiHTTPResponse<IMPESASTKPush>> {
    return this.http.post<ISibasiHTTPResponse<IMPESASTKPush>>(
      `${environment.api_url}mobilemoney/initiate/pay/stkpush`,
      MPESASTKPush
    );
  }

  public triggerMPESASTKPushForInvoice(
    MPESASTKPush: any
  ): Observable<ISibasiHTTPResponse<IMPESASTKPush>> {
    return this.http.post<ISibasiHTTPResponse<IMPESASTKPush>>(
      `${environment.api_url}Sibasi_Subscription_Item_License_Invoice/stkPush/pay/${MPESASTKPush.invoiceId}`,
      { phoneNumber: MPESASTKPush.phoneNumber }
    );
  }

  public validatePaybillCode(
    invoiceId: string | undefined,
    mpesaCode: string
  ): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}Sibasi_Subscription_Item_License_Invoice/paybill/confirm/${invoiceId}/${mpesaCode}`
    );
  }

  // *************** STRIPE PAYMENT ***************
  public payWithStripe(
    subscriptionLicenseInvoiceId: string | undefined
  ): Observable<any> {
    return this.http.get<any>(
      `${environment.api_url}Sibasi_Subscription_Item_License_Invoice/stripe/pay/${subscriptionLicenseInvoiceId}`
    );
  }
  public checkoutWithStripe(
    stripePaymentTransactionId: string
  ): Observable<ISibasiHTTPResponse<IMPESASTKPush>> {
    return this.http.get<ISibasiHTTPResponse<IMPESASTKPush>>(
      `${environment.api_url}stripe/checkout/session/create/${stripePaymentTransactionId}`
    );
  }

  // *************** VOUCHER PAYMENT ***************
  activateLicenseWithVoucher(voucherCode: string): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}sibasi-subscription-item-licenses/activate/voucher/${voucherCode}`
    );
  }
  // *************** PAYMENT RECORDS ***************

  public getTransactionLicenseInvoicePaymentRecord(
    invoiceId: string
  ): Observable<ISibasiHTTPResponse<IMPESASTKPush>> {
    return this.http.get<ISibasiHTTPResponse<IMPESASTKPush>>(
      `${environment.api_url}Sibasi_Subscription_Item_License_Invoice/paymentRecord/${invoiceId}`
    );
  }

  // *************** SUBSCRIPTION ITEM INVOICES ***************

  public getAllSubscriptionLicenseInvoices(): Observable<
    ISibasiHTTPResponse<ISubscriptionLicenseInvoice[]>
  > {
    return this.http.get<ISibasiHTTPResponse<ISubscriptionLicenseInvoice[]>>(
      `${environment.api_url}Sibasi_Subscription_Item_License_Invoice`
    );
  }
  public getSubscriptionLicenseInvoiceById(
    licensePackageId: string
  ): Observable<ISibasiHTTPResponse<ISubscriptionLicenseInvoice>> {
    return this.http.get<ISibasiHTTPResponse<ISubscriptionLicenseInvoice>>(
      `${environment.api_url}Sibasi_Subscription_Item_License_Invoice/${licensePackageId}`
    );
  }
  public addSubscriptionLicenseInvoice(
    subscriptionLicenseInvoice: ISubscriptionLicenseInvoice
  ): Observable<ISibasiHTTPResponse<ISubscriptionLicenseInvoice>> {
    return this.http.post<ISibasiHTTPResponse<ISubscriptionLicenseInvoice>>(
      `${environment.api_url}Sibasi_Subscription_Item_License_Invoice`,
      subscriptionLicenseInvoice
    );
  }
  public deleteSubscriptionLicenseInvoice(
    subscriptionLicenseInvoiceId: any
  ): Observable<ISibasiHTTPResponse<ISubscriptionLicenseInvoice>> {
    return this.http.delete<ISibasiHTTPResponse<ISubscriptionLicenseInvoice>>(
      `${environment.api_url}Sibasi_Subscription_Item_License_Invoice/${subscriptionLicenseInvoiceId}`
    );
  }
  public updateSubscriptionLicenseInvoice(
    subscriptionLicenseInvoiceId: any,
    subscriptionLicenseInvoice: ISubscriptionLicenseInvoice
  ): Observable<ISibasiHTTPResponse<ISubscriptionLicenseInvoice>> {
    return this.http.post<ISibasiHTTPResponse<ISubscriptionLicenseInvoice>>(
      `${environment.api_url}Sibasi_Subscription_Item_License_Invoice/${subscriptionLicenseInvoiceId}`,
      subscriptionLicenseInvoice
    );
  }

  // *************** SUBSCRIPTION MODULES ***************

  public getAllSystemModules(): Observable<ISibasiHTTPResponse<any[]>> {
    return this.http.get<ISibasiHTTPResponse<any[]>>(
      `${environment.api_url}sibasi-subscription-item-licenses/systemModules/all`
    );
  }

  public getSubscribedModules(): Observable<ISibasiHTTPResponse<any[]>> {
    return this.http.get<ISibasiHTTPResponse<any[]>>(
      `${environment.api_url}sibasi-subscription-item-licenses/subscribedModules/all`
    );
  }

  async checkIfMOdulesAreSubscribed(
    subscriptionModulesToCheck: SIBASI_SYSTEM_APP_MODULES[]
  ): Promise<boolean> {
    try {
      const response = await this.getSubscribedModules().toPromise();
      const subscribedModules = response?.result;
      const isSubscribed = subscriptionModulesToCheck.some((moduleName) =>
        subscribedModules?.includes(moduleName)
      );
      return isSubscribed;
    } catch (error) {
      return false;
    }
  }

  public getRemainingTransactionStarterPlan(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/dashboard/licensing/transactionCount/remaining`
    );
  }
  public getRemainingContactsStarterPlan(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}pos/dashboard/licensing/contactsCount/remaining`
    );
  }

  // *************** SUBSCRIPTION REFERRAL ***************

  public getUserReferrals(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}referral/sibasi-subscription/mine/all`
    );
  }

  // *************** ADMIN PAID LICENSES ***************
  public getPaginatedPaidLicenses(
    pagination?: any
  ): Observable<ISibasiHTTPResponse<IPagination<any[]>>> {
    return this.http.post<ISibasiHTTPResponse<IPagination<any[]>>>(
      `${environment.api_url}sibasi-subscription-item-licenses/admin/aggregateLicenses/paginated`,
      pagination ? pagination : {}
    );
  }

  public getAllSearchedPaidLicensesCount(
    searchText: string
  ): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}sibasi-subscription-item-licenses/admin/aggregateLicenses/searched/count/${searchText}`
    );
  }
  getAllPaidLicensesCount(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}sibasi-subscription-item-licenses/admin/aggregateLicenses/count`
    );
  }

  getAllPaidLicenses(): Observable<ISibasiHTTPResponse<any>> {
    return this.http.get<ISibasiHTTPResponse<any>>(
      `${environment.api_url}sibasi-subscription-item-licenses/admin/aggregateLicenses/all`
    );
  }
}
